import Chart from "react-apexcharts";
import { FiHome } from "react-icons/fi";
import useStatistics from "../../../marketplace_admin/libs/useStatistics";
import PageHeader from "../../components/PageHeader";
import StatCard from "../../components/StatCard";
import Spinner from "../../../Spinner/Spinner";

const AdminOverviewPage = () => {
  const { data: statistics, error, isLoading, refetch, isFetching } = useStatistics();

  const chartOptions = {
    chart: { toolbar: { show: false } },
    xaxis: { categories: statistics?.dailyRevenue?.map((d) => d.date.slice(5)) || [] },
    colors: ["#284697"],
    stroke: { curve: "smooth" },
  };
  const chartSeries = [{ name: "Revenue (NGN)", data: statistics?.dailyRevenue?.map((d) => d.amount) || [] }];

  const statCards = statistics
    ? [
        { label: "Products", value: statistics.totalProducts },
        { label: "Orders", value: statistics.totalOrders },
        { label: "Revenue", value: `NGN ${(statistics.totalRevenue || 0).toLocaleString()}` },
        { label: "Commission", value: `NGN ${(statistics.totalCommission || 0).toLocaleString()}` },
        { label: "Merchants", value: statistics.totalMerchants },
        { label: "Customers", value: statistics.totalCustomers },
        { label: "Pending orders", value: statistics.pendingOrders },
        { label: "Delivered", value: statistics.completedOrders },
        { label: "Shipped", value: statistics.shippedOrders },
        { label: "Canceled", value: statistics.canceledOrders },
        { label: "COD orders", value: statistics.codOrders },
        { label: "Returns", value: statistics.returnRequests },
        { label: "Refunded", value: statistics.refundedOrders },
      ]
    : [];

  return (
    <>
      <PageHeader title="Overview" subtitle="Marketplace performance" icon={FiHome} />
      {isLoading && <Spinner />}
      {error && (
        <div className="dashboard-card" style={{ marginBottom: 16 }}>
          <p style={{ color: "var(--dash-danger)", margin: "0 0 12px" }}>
            Could not load statistics{error.message ? `: ${error.message}` : "."}
          </p>
          <button type="button" className="dashboard-btn dashboard-btn--secondary" onClick={() => refetch()}>
            {isFetching ? "Retrying…" : "Retry"}
          </button>
        </div>
      )}
      {!isLoading && statistics && (
        <>
          <div className="dashboard-stat-grid">
            {statCards.map((c) => (
              <StatCard key={c.label} label={c.label} value={c.value} />
            ))}
          </div>
          <div className="dashboard-card">
            <h2 className="dashboard-card__title">Revenue (last 30 days)</h2>
            {statistics.dailyRevenue?.length > 0 ? (
              <Chart options={chartOptions} series={chartSeries} type="area" height={320} />
            ) : (
              <p style={{ color: "var(--dash-muted)" }}>No revenue data yet.</p>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default AdminOverviewPage;
